import { type Room } from 'livekit-client'

import { findNearestText } from 'modules/ai_voice/lib/observers/find-text'
import { performRpc } from 'modules/ai_voice/lib/rpc'

let handleClick: ((event: MouseEvent) => void) | null = null

export function registerClickObserver(room: Room): void {
  function notifyElementClicked(element: string) {
    performRpc(room, 'elementClicked', { element }).catch(() => {})
  }

  handleClick = (event) => {
    if (!event.isTrusted || !(event.target instanceof HTMLElement)) {
      return
    }

    const interactiveElement = event.target.closest('button, a')

    if (!(interactiveElement instanceof HTMLElement)) {
      return
    }

    const element = findNearestText(interactiveElement)
    notifyElementClicked(element)
  }

  document.addEventListener('click', handleClick, true)
}

export function unregisterClickObserver(): void {
  if (handleClick) {
    document.removeEventListener('click', handleClick, true)
    handleClick = null
  }
}
